import { useEffect, useState } from "react";
import "./ScrollProgress.css";

function readScrollProgress() {
  const scrollable = document.documentElement.scrollHeight - window.innerHeight;
  if (scrollable <= 0) return 0;
  return Math.min(Math.max(window.scrollY / scrollable, 0), 1);
}

/** Lightweight scroll progress — native listener (no framer useScroll). */
export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = 0;

    const tick = () => {
      raf = 0;
      setProgress(readScrollProgress());
    };

    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(tick);
    };

    tick();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="ds-scroll-progress" aria-hidden="true" data-testid="scroll-progress">
      <div className="ds-scroll-progress__line" />
      <div
        className="ds-scroll-progress__fill"
        style={{ transform: `scaleY(${progress})` }}
      />
      <div className="ds-scroll-progress__dot" style={{ top: `${progress * 100}%` }} />
    </div>
  );
}
